export default "__VITE_ASSET__Bj6WJy1s__"